// @flow
import React, {PureComponent} from 'react';
import ReactSlider from '../ReactSlider/ReactSlider';
import './Slider.less';
import SliderHandle from '../SliderHandle/SliderHandle';
import {GENERIC_EVENT, trigger as edapTrigger} from '../../utils/edapWrapper';
import {debounce} from 'lodash';

import type {Bounds} from '../ReactSlider/ReactSlider';
import classNames from 'classnames';

type Props = {
    min?: number,
    max: number,
    step: number,
    start: number,
    stop: number,
    onChange: (Array<number | null>) => void,
    onSetActiveHandle?: (index: ?number) => void,
    className?: string,
    edapLabel?: string
};

type State = {
    value: [number]
};

const MIN_SPACING_INTERVAL = 20;

class Slider extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.triggerEdapEvent = debounce(this.triggerEdapEvent, 200, {
            leading: false,
            trailing: true
        });
        this.minSpacing = (props.max - (props.min || 0)) / MIN_SPACING_INTERVAL;
    }

    minSpacing: number = 0;

    handleChange = (bounds: Bounds) => {
        const {onSetActiveHandle, onChange, edapLabel} = this.props;
        const {start} = this.props;
        let [newStart, newStop] = bounds;
        const activeHandlerIndex: number = start !== newStart ? 0 : 1;

        if (edapLabel) {
            const eventlabel = `${edapLabel}${
                start !== newStart ? `_min_${newStart}` : `_max_${newStop}`
            }`;

            this.triggerEdapEvent(eventlabel);
        }

        if (onSetActiveHandle) {
            onSetActiveHandle(activeHandlerIndex);
        }

        onChange([newStart, newStop]);
    };

    triggerEdapEvent = (eventlabel: string) => {
        const eventObj = {
            eventaction: 'filter selected',
            eventlabel
        };
        edapTrigger(GENERIC_EVENT, eventObj);
    };

    handleAfterChange = () => {
        const {onSetActiveHandle} = this.props;
        if (onSetActiveHandle) {
            onSetActiveHandle(null);
        }
    };

    connectedSliderHandle = (index: number) => {
        const {onSetActiveHandle} = this.props;
        return (
            <SliderHandle
                key={index}
                index={index}
                onSetActiveHandle={onSetActiveHandle}
            />
        );
    };

    render() {
        const {min, max, step, className = '', start, stop} = this.props;
        const classes = classNames('Slider', {
            [className]: className
        });

        return (
            <ReactSlider
                className={classes}
                handleClassName={'SliderHandle'}
                handleActiveClassName={'SliderHandle--active'}
                barClassName={'Slider__bar'}
                min={min}
                max={max}
                step={step}
                minDistance={this.minSpacing}
                value={[start, stop]}
                onChange={this.handleChange}
                onAfterChange={this.handleAfterChange}
                renderHandle={this.connectedSliderHandle}
                withBars
            />
        );
    }
}

export default Slider;
